import buildRawQueryBase from './build-raw-query-base';
import getItemsToDisplayIds from './get-items-to-display-ids';
import getExtraAzBits from './get-extra-az-bits';
import buildAzFilter from './build-az-filter';
import { AND_OPERATOR, AZ_DEFAULT_PROP } from '../constants';

const buildRawQuery = ({
  docType,
  operator,
  searchValues = {},
  filterData,
  id,
  itemsToDisplay,
  shouldApplySort,
  azOptions
}) => {
  const {
    searchValuesText: { must: searchValuesText = [], should: shouldValuesText = [] } = {},
    searchValuesCheckboxSelectRange = [],
    searchValuesCheckboxOr = []
  } = searchValues;
  const { filterValues, filterOperator, relations, stringProps, azFilter } = filterData;

  const { isAZ, sortProperties = [] } = azOptions || {};
  const sortPropertyToUse = isAZ && sortProperties[0] && sortProperties[0].isScore ? 1 : 0;
  const { propsToDisplay: [azSortProp] = [] } = sortProperties[sortPropertyToUse] || {
    propsToDisplay: []
  };
  const azSortProperty = azSortProp || AZ_DEFAULT_PROP;

  const searchValuesTextCheckboxSelectJoined =
    operator === AND_OPERATOR ? [...searchValuesText, ...searchValuesCheckboxSelectRange] : [];
  let searchValuesTextCheckboxOr = searchValuesText;
  if (searchValuesCheckboxOr.length) {
    searchValuesTextCheckboxOr = [...searchValuesText, ...searchValuesCheckboxOr];
  }

  let finalValue;

  if (searchValuesTextCheckboxSelectJoined.length) {
    const finalValueWithCheckboxOrValues = {
      must: [...searchValuesTextCheckboxSelectJoined, { bool: { should: searchValuesCheckboxOr } }]
    };
    const finalValueIfNoCheckboxOrValues = { must: searchValuesTextCheckboxSelectJoined };
    finalValue = searchValuesCheckboxOr.length
      ? finalValueWithCheckboxOrValues
      : finalValueIfNoCheckboxOrValues;
  } else {
    finalValue = {
      must: [
        ...searchValuesCheckboxSelectRange,
        { bool: { should: [...searchValuesTextCheckboxOr, ...shouldValuesText] } }
      ]
    };
  }
  const mustValues = [
    {
      bool: finalValue
    }
  ];

  buildAzFilter(azFilter, mustValues, azSortProperty);

  const { should: baseShould = [], ...baseQuery } = buildRawQueryBase({
    docType,
    id,
    filterValues,
    filterOperator,
    relations,
    stringProps
  });
  const shouldValue = [...baseShould, ...shouldValuesText];
  const query = {
    bool: {
      must: mustValues,
      should: shouldValue.length ? shouldValue : undefined,
      ...baseQuery
    }
  };
  const azQueryBits = getExtraAzBits({ ...azOptions, azSortProperty, azFilter });

  if (itemsToDisplay && itemsToDisplay.length) {
    const itemsToDisplayIds = getItemsToDisplayIds(itemsToDisplay);

    query.bool.must.push({ ids: { values: itemsToDisplayIds } });
    if (shouldApplySort) {
      return {
        query,
        sort: [
          {
            _script: {
              type: 'number',
              script: {
                lang: 'painless',
                source:
                  "!doc['id.keyword'].empty ? params.sortOrder.indexOf(doc['id.keyword'].value) : 0",
                params: {
                  sortOrder: itemsToDisplayIds
                }
              },
              order: 'asc'
            }
          }
        ],
        ...azQueryBits
      };
    }
  }

  return isAZ
    ? {
        query,
        ...azQueryBits
      }
    : query;
};

export default buildRawQuery;
